/* VeltronShop 2027 - apparitions au defilement, barre d'achat fixe, description de collection depliable. Aucune dependance. */
(function () {
  'use strict';

  var ROOT = document.documentElement;
  /* Script arrive apres 3 s : le filet de securite CSS a deja affiche les blocs, on ne rejoue pas leur animation */
  var LATE_START = !!(window.performance && typeof performance.now === 'function' && performance.now() > 3000);

  /* Execute une etape sans qu'une erreur n'empeche les autres ; renvoie false si elle a echoue */
  function safely(step) {
    try {
      return step();
    } catch (error) {
      if (window.console && console.error) console.error('[veltron]', error);
      return false;
    }
  }

  function initReveal() {
    var els = document.querySelectorAll('.vt-reveal:not(.is-in)');
    if (!els.length) return true;
    if (LATE_START || !('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
      return true;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    for (var j = 0; j < els.length; j++) io.observe(els[j]);
    setTimeout(function () {
      var rest = document.querySelectorAll('.vt-reveal:not(.is-in)');
      for (var k = 0; k < rest.length; k++) {
        if (rest[k].getBoundingClientRect().top < window.innerHeight) rest[k].classList.add('is-in');
      }
    }, 1500);
    return true;
  }

  function initSticky() {
    var bar = document.querySelector('[data-vt-sticky]');
    if (!bar || bar.dataset.vtReady) return;
    var main = document.querySelector('main');
    var target = main && main.querySelector("form[action*='/cart/add'] [type='submit']");
    var trigger = bar.querySelector('[data-vt-sticky-btn]');
    if (!target || !trigger || !('IntersectionObserver' in window)) return;
    bar.dataset.vtReady = '1';
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.inert = !show;
    }, { threshold: 0 });
    io.observe(target);
    trigger.addEventListener('click', function () { target.click(); });
  }

  function initDescriptions() {
    var boxes = document.querySelectorAll('[data-vt-desc]');
    for (var i = 0; i < boxes.length; i++) {
      (function (box) {
        var btn = box.parentElement && box.parentElement.querySelector('[data-vt-more]');
        if (!btn || btn.dataset.vtReady) return;
        btn.dataset.vtReady = '1';
        if (box.scrollHeight <= box.clientHeight + 2) { btn.hidden = true; return; }
        btn.addEventListener('click', function () {
          var open = box.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
        });
      })(boxes[i]);
    }
  }

  function init() {
    var revealed = safely(initReveal);
    safely(initSticky);
    safely(initDescriptions);
    /* vt-ready annule le filet de securite CSS ; il n'est pose que si les apparitions sont bien en place */
    if (revealed !== false) ROOT.classList.add('vt-ready');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();